import { useNavigate } from "react-router-dom";
import background from "../assets/Background.jpg";

function RestrictedPage() {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate("/", { replace: true });
    };

    return (
        <div className="page-root" style={{
            background: `url(${background}) center center / cover no-repeat fixed`,
        }}>
            <div className="overlay-card">
                <h2 className="title">Access Restricted</h2>

                <p style={{ marginTop: "1rem" }}>
                    Unfortunately, the viewing of this content is not permitted in the
                    territory that you are located.
                </p>

                <p style={{ marginTop: "0.75rem", fontSize: "0.95rem" }}>
                    This webcast is subject to regional access restrictions. If you
                    believe you are seeing this message in error, please contact your
                    BRR Media representative.
                </p>

                <div className="divider" />

                <p style={{ marginBottom: "1.5rem", fontWeight: 600 }}>BRR Media</p>

                <div className="buttons">
                    <button className="btn btn-success" onClick={handleBack}>
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RestrictedPage;
